export { Header };

function Header() {
    return (
        <header>
            <div className="container-fluid">
                <div className="row">
                    <div className="col pleca text-center">
                        <img src="https://www.yvesrocher.com.mx/Resources/images/Logitipo%20home.svg" alt="" />
                    </div>
                </div>
            </div>
        </header>
    );
}